import React from 'react';
import ReactDOM from 'react-dom/client';
import axios from 'axios';
import "@/index.css";
import App from '@/App';

// Global axios interceptor — auto-attach the admin session token on every
// outgoing request when it's present in localStorage. This keeps admin pages
// working transparently while all sensitive backend endpoints require the
// x-admin-token header. Public endpoints ignore the header entirely.
axios.interceptors.request.use((config) => {
  try {
    const token = localStorage.getItem('adminToken') || localStorage.getItem('admin_token');
    if (token) {
      config.headers = config.headers || {};
      if (!config.headers['x-admin-token']) {
        config.headers['x-admin-token'] = token;
      }
    }
  } catch (_) { /* localStorage unavailable — fall through */ }
  return config;
});

// PWA service worker — network-first (no caching) so content is always live.
// This SW is required for the site to be installable as an APK / Add to Home
// Screen. See /public/service-worker.js for the implementation.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .catch((err) => console.error('Service Worker registration failed:', err));
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
